import {Injectable} from '@angular/core';
import {MesApiService} from "./mes-api.service";
import {getBase64} from "./helpers/string-helper";
import {map, switchMap} from "rxjs/operators";
import {FileLinkModel} from "./models/file-link.model";

@Injectable({
  providedIn: 'root'
})
export class FileService extends MesApiService {

  constructor() {
    super('file');
  }

  download(fileName: string, folderCode: string = null, preview: boolean = false) {
    let url = '/file/' + fileName;
    if (folderCode) {
      url += '/' + folderCode;
    }
    if (preview) {
      url += '/true';
    }
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  uploadBase64(file: File, fileLinkModel: FileLinkModel = null) {
    return getBase64(file).pipe(switchMap(fileData => {
      if (!fileData) {
        console.error('No filedata');
        throw new Error('No filedata');
      }
      fileLinkModel ??= new FileLinkModel();
      fileLinkModel.FileName = file.name;
      fileLinkModel.Base64 = fileData;
      return this.add<FileLinkModel>(
        fileLinkModel,
        {action: 'UploadBase64'}
      ).pipe(map(value => {
        return value.data;
      }));
    }));
  }
}
